$('.single-slider').not('.slick-initialized').slick({
    infinite: true,
    slidesToScroll: 3,
    prevArrow: $('.single-slider-prev-arrow'),
    nextArrow: $('.single-slider-next-arrow'),
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
        {
            breakpoint: 1023,
            settings: {
                infinite: true,
                centerMode: true,
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                infinite: true,
                centerMode: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: false,
                nextArrow: false,
            }
        }
    ]
});

$(function () {
    $('.slider').not('.slick-initialized').slick({
        infinite: true,
        rows: 0,
        slidesToScroll: 2,
        prevArrow: $('.prev-arrow'),
        nextArrow: $('.next-arrow'),
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    prevArrow: false,
                    nextArrow: false,
                    infinite: true,
                    centerMode: true,
                    slidesToShow: 1,
                }
            }
        ]
    });
});

// SECOND SLIDER
